export default "__VITE_ASSET__BsF9daE5__"